import { render, staticRenderFns } from "./CareerPathwayView.vue?vue&type=template&id=137c99cc&scoped=true"
import script from "./CareerPathwayView.vue?vue&type=script&lang=js"
export * from "./CareerPathwayView.vue?vue&type=script&lang=js"
import style0 from "./CareerPathwayView.vue?vue&type=style&index=0&id=137c99cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137c99cc",
  null
  
)

export default component.exports